import { render, staticRenderFns } from "./goods-management-search.vue?vue&type=template&id=239f592e&scoped=true"
import script from "./goods-management-search.vue?vue&type=script&lang=js"
export * from "./goods-management-search.vue?vue&type=script&lang=js"
import style0 from "./goods-management-search.vue?vue&type=style&index=0&id=239f592e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f592e",
  null
  
)

export default component.exports